export const translations = {
  fr: {
    'explorer': 'EXPLORATEUR',
    'select.file': 'Sélectionnez un fichier pour commencer',
    'portfolio': 'Portfolio',
    'menu.file': 'Fichier',
    'menu.edit': 'Édition',
    'menu.selection': 'Sélection',
    'menu.view': 'Affichage',
    'menu.go': 'Aller à',
    'menu.run': 'Exécuter',
    'menu.terminal': 'Terminal',
    'menu.help': 'Aide',
    'settings': 'Paramètres',
    'settings.language': 'Langue',
    'settings.languageDescription': 'Choisissez la langue de l\'interface',
    'status.connected': 'Connecté',
    'status.main': 'principal',
    'preview.button': 'Aperçu',
    'editor.button': 'Éditeur',
    'open.folder': 'Ouvrir un dossier',
    'open.file': 'Ouvrir un fichier',
    'counter.preview': 'Aperçu du compteur',
    'counter.increment': 'Incrémenter',
    'counter.reset': 'Réinitialiser',
    'counter.state': 'État actuel',
    'counter.notes': 'Notes du composant',
    'preview.default': 'Aperçu du composant',
    'home.title': 'Full Stack Engineer',
    'home.description': "",
    'home.welcome': 'Bienvenue sur mon portfolio VS Code !',
    'home.guide': "Comme dans VS Code, vous pouvez explorer les fichiers dans la barre latérale gauche. J'ai même ajouté un vrai terminal fonctionnel en bas - promis, il ne formatera pas votre disque dur ! 😉",
    'home.tip': 'Astuce : Les boutons qui brillent ne sont pas juste pour faire joli, ils font vraiment quelque chose.',
    'home.ps': 'P.S. : Si vous trouvez un bug, ce n\'est pas un bug, c\'est une feature non documentée.',
    'contact.name': 'Nom',
    'contact.email': 'Email',
    'contact.subject': 'Sujet',
    'contact.message': 'Message',
    'contact.send': 'Envoyer',
    'contact.sending': 'Envoi en cours...',
    'contact.success': 'Message envoyé avec succès !',
    'contact.error': 'Une erreur est survenue. Veuillez réessayer.'
  },
  en: {
    'explorer': 'EXPLORER',
    'select.file': 'Select a file to start',
    'portfolio': 'Portfolio',
    'menu.file': 'File',
    'menu.edit': 'Edit',
    'menu.selection': 'Selection',
    'menu.view': 'View',
    'menu.go': 'Go',
    'menu.run': 'Run',
    'menu.terminal': 'Terminal',
    'menu.help': 'Help',
    'settings': 'Settings',
    'settings.language': 'Language',
    'settings.languageDescription': 'Choose interface language',
    'status.connected': 'Connected',
    'status.main': 'main',
    'preview.button': 'Preview',
    'editor.button': 'Editor',
    'open.folder': 'Open Folder',
    'open.file': 'Open File',
    'counter.preview': 'Counter Preview',
    'counter.increment': 'Increment',
    'counter.reset': 'Reset',
    'counter.state': 'Current state',
    'counter.notes': 'Component Notes',
    'preview.default': 'Component Preview',
    'home.title': 'Full Stack Engineer',
    'home.description': "",
    'home.welcome': 'Welcome to my VS Code portfolio!',
    'home.guide': "Just like in VS Code, you can explore files in the left sidebar. I've even added a working terminal at the bottom - promise it won't format your hard drive! 😉",
    'home.tip': 'Pro tip: The shimmering buttons aren\'t just for show, they actually do something.',
    'home.ps': 'P.S.: If you find a bug, it\'s not a bug, it\'s an undocumented feature.',
    'contact.name': 'Name',
    'contact.email': 'Email',
    'contact.subject': 'Subject',
    'contact.message': 'Message',
    'contact.send': 'Send',
    'contact.sending': 'Sending...',
    'contact.success': 'Message sent successfully!',
    'contact.error': 'An error occurred. Please try again.'
  }
}; 